import * as React from 'react';

import Radium from '@flipdish/radium';
import { find } from 'lodash';
import { Link } from 'react-router';

import {
  Divider,
  Hidden,
  Icon,
  SectionHeader,
  SectionHeaderIcon,
  SectionHeaderText,
} from '../../../ui';
import { CollectionIcon } from '../../../ui/Icon/AppIcons';
import { Track } from '../../analytics';
import * as Api from '../../Api';
import { Utilities } from '../../Utilities';
import LoadingPanel from '../LoadingPanel';
import { MainLayout } from '../MainLayout/MainLayout';
import PermissionConsentDialog from '../PermissionConsentDialog';
import { AboutMyData } from '../SecureWarningModal/AboutMyData';
import { DispatchProps, StateProps } from './index';

const tinycolor = require('tinycolor2');

type Props = DispatchProps & StateProps;

class Delivery extends React.Component<Props> {
  constructor(props: Props, context: any) {
    super(props, context);
  }

  public componentDidMount() {
    const firstEl = document.querySelector('#skip-to-content');
    if (firstEl) {
      Utilities.ensureVisible(firstEl);
    }
    this.props.PushLoginUrl();
  }

  // TODO should be in PageLayout > Back component
  public backLink = (): JSX.Element | null => {
    const { AppConfig, AppDesignScheme, isDark } = this.props;
    if (AppConfig.status != 'success') {
      return null;
    }

    const styles = {
      nav: {
        ':hover': {},
        ':active': {},
      },
      secondaryActive: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString(),
      },
      secondaryHover: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString(),
      },
      tertiary: {
        color: AppDesignScheme.Tertiary,
      },
      primary: {
        color: AppDesignScheme.Primary,
      },
    };

    if (AppConfig.data.PickupEnabled) {
      return (
        <Link to="/where" data-fd="delivery-back">
          <div
            key="fd-nav"
            className="fd-nav flex flex-align-center"
            style={styles.nav as any}
          >
            <i
              className="arrow_carrot-left tertiary"
              style={
                Radium.getState(this.state, 'fd-nav', ':active')
                  ? styles.secondaryActive
                  : Radium.getState(this.state, 'fd-nav', ':hover')
                  ? styles.secondaryHover
                  : isDark
                  ? styles.primary
                  : styles.tertiary
              }
              aria-hidden="true"
            />
            <p
              className="inline-block clear-margins tertiary bold"
              style={
                Radium.getState(this.state, 'fd-nav', ':active')
                  ? styles.secondaryActive
                  : Radium.getState(this.state, 'fd-nav', ':hover')
                  ? styles.secondaryHover
                  : isDark
                  ? styles.primary
                  : styles.tertiary
              }
            >
              <u>{this.props.translate('Back')}</u>
            </p>
          </div>
        </Link>
      );
    }
    if (this.props.LastRestaurantUrl !== '/') {
      return (
        <Link to={this.props.LastRestaurantUrl}>
          <div
            key="fd-nav"
            className="fd-nav flex flex-align-center"
            style={styles.nav as any}
          >
            <i
              className="arrow_carrot-left tertiary"
              style={
                Radium.getState(this.state, 'fd-nav', ':active')
                  ? styles.secondaryActive
                  : Radium.getState(this.state, 'fd-nav', ':hover')
                  ? styles.secondaryHover
                  : isDark
                  ? styles.primary
                  : styles.tertiary
              }
              aria-hidden="true"
            />
            <p
              className="inline-block clear-margins tertiary bold"
              style={
                Radium.getState(this.state, 'fd-nav', ':active')
                  ? styles.secondaryActive
                  : Radium.getState(this.state, 'fd-nav', ':hover')
                  ? styles.secondaryHover
                  : isDark
                  ? styles.primary
                  : styles.tertiary
              }
            >
              <u>{this.props.translate('Menu')}</u>
            </p>
          </div>
        </Link>
      );
    }
    return null;
  };

  public deliveryLocationUrl = (dl: Api.DeliveryLocation): string => {
    const option = this.props.deliveryOptions[dl.DeliveryLocationId];

    if (!option || option.status != 'success') {
      // Trying to click on a delivery location before the options are loaded
      return '/delivery/' + dl.DeliveryLocationId;
    }

    switch (option.data.type) {
      case 'choice':
        return '/delivery/' + dl.DeliveryLocationId;

      case 'skip':
        return (
          '/restaurant/' +
          option.data.to.VirtualRestaurantId +
          '/delivery/' +
          dl.DeliveryLocationId
        );
    }
  };

  // TODO ui component
  public newLocationButton = (): JSX.Element | null => {
    const {
      AppConfig,
      DeliveryLocations,
      translate,
      AppDesignScheme,
      isDark,
    } = this.props;

    if (AppConfig.status != 'success') {
      return null;
    }

    let message = translate('Enter_an_address_for_delivery');
    if (
      DeliveryLocations.status === 'success' &&
      DeliveryLocations.data.length > 0
    ) {
      message = translate('Deliver_to_a_new_address');
    }

    // const { MapCenterLatitude, MapCenterLongitude } = AppConfig.data;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary,
      },
      secondary: {
        color: AppDesignScheme.Secondary,
      },
      tertiary: {
        color: AppDesignScheme.Tertiary,
      },
      cell: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .setAlpha(0.2)
          .toString(),
        ':hover': {
          borderColor: AppDesignScheme.Secondary,
          boxShadow: `-2px 2px 9px -5px ${AppDesignScheme.Secondary}`,
          backgroundColor: tinycolor(AppDesignScheme.Primary)
            .darken(3)
            .toString(),
        },
        ':active': {
          borderColor: AppDesignScheme.Secondary,
          boxShadow: `-2px 2px 9px -5px ${AppDesignScheme.Secondary}`,
          backgroundColor: tinycolor(AppDesignScheme.Tertiary)
            .setAlpha(0.1)
            .toString(),
        },
      },
      darkCell: {
        borderColor: AppDesignScheme.Primary,
        ':hover': {
          backgroundColor: 'transparent',
          borderColor: AppDesignScheme.Secondary,
          boxShadow: 'none',
        },
        ':active': {
          borderColor: AppDesignScheme.Secondary,
          boxShadow: `-2px 2px 9px -5px ${AppDesignScheme.Secondary}`,
          backgroundColor: tinycolor(AppDesignScheme.Tertiary)
            .lighten(10)
            .toString(),
        },
      },
      darkMap: {
        borderColor: AppDesignScheme.Primary,
      },
      map: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .setAlpha(0.2)
          .toString(),
      },
      mapHover: {
        borderColor: AppDesignScheme.Secondary,
      },
    };

    return (
      <Link to="/delivery/new" data-fd="delivery-new">
        <div
          key="delivery-new"
          className="delivery__cell flex flex-align-start flex-justify-between"
          style={isDark ? styles.darkCell : styles.cell}
        >
          <div className="flex flex-align-center">
            <i
              className="icon_pin tertiary"
              style={
                Radium.getState(this.state, 'delivery-new', ':active') ||
                Radium.getState(this.state, 'delivery-new', ':hover')
                  ? styles.secondary
                  : isDark
                  ? styles.primary
                  : styles.tertiary
              }
              aria-hidden="true"
            />
            <p
              className="inline-block clear-margins tertiary fd-h4"
              style={
                Radium.getState(this.state, 'delivery-new', ':active') ||
                Radium.getState(this.state, 'delivery-new', ':hover')
                  ? styles.secondary
                  : isDark
                  ? styles.primary
                  : styles.tertiary
              }
            >
              {message}
            </p>
          </div>

          {/* <div
            className="delivery__cell__map"
            style={
              Radium.getState(this.state, 'delivery-new', ':active') ||
              Radium.getState(this.state, 'delivery-new', ':hover')
                ? styles.mapHover
                : isDark
                ? styles.darkMap
                : styles.map
            }
          >
            <GoogleMap
              center={[MapCenterLatitude, MapCenterLongitude]}
              width={128}
              height={96}
              zoom={13}
              scale={2}
              apiKey="AIzaSyDPmaK_ZeZzYITQHT9KpftobsXIz3r8SWo"
              stretch={false}
            />
          </div> */}
        </div>
      </Link>
    );
  };

  // TODO ui component
  public locationButton = (dl: Api.DeliveryLocation): JSX.Element => {
    const options = this.props.deliveryOptions[dl.DeliveryLocationId];

    const { AppDesignScheme, isDark, AppConfig } = this.props;

    if (AppConfig.status != 'success') {
      return null;
    }

    const styles = {
      primary: {
        color: AppDesignScheme.Primary,
      },
      secondary: {
        color: AppDesignScheme.Secondary,
      },
      tertiary: {
        color: AppDesignScheme.Tertiary,
      },
      cell: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .setAlpha(0.2)
          .toString(),
        ':hover': {
          borderColor: AppDesignScheme.Secondary,
          boxShadow: `-2px 2px 9px -5px ${AppDesignScheme.Secondary}`,
          backgroundColor: tinycolor(AppDesignScheme.Primary)
            .darken(3)
            .toString(),
        },
        ':active': {
          borderColor: AppDesignScheme.Secondary,
          boxShadow: `-2px 2px 9px -5px ${AppDesignScheme.Secondary}`,
          backgroundColor: tinycolor(AppDesignScheme.Tertiary)
            .setAlpha(0.1)
            .toString(),
        },
      },
      darkCell: {
        borderColor: AppDesignScheme.Primary,
        ':hover': {
          backgroundColor: 'transparent',
          borderColor: AppDesignScheme.Secondary,
          boxShadow: 'none',
        },
        ':active': {
          borderColor: AppDesignScheme.Secondary,
          boxShadow: `-2px 2px 9px -5px ${AppDesignScheme.Secondary}`,
          backgroundColor: tinycolor(AppDesignScheme.Tertiary)
            .lighten(10)
            .toString(),
        },
      },
      map: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .setAlpha(0.2)
          .toString(),
      },
      darkMap: {
        borderColor: AppDesignScheme.Primary,
      },
      mapHover: {
        borderColor: AppDesignScheme.Secondary,
      },
    };

    if (!options || options.status != 'success') {
      return (
        <div key={dl.DeliveryLocationId}>
          <h2 className="tertiary clear-margins" style={styles.tertiary}>
            {this.props.translate('Loading_delivery_options')}
          </h2>
        </div>
      );
    }

    // const markers: Array<[number, number]> = [
    //   [dl.Coordinates.Latitude, dl.Coordinates.Longitude],
    // ];

    return (
      <Link key={dl.DeliveryLocationId} to={this.deliveryLocationUrl(dl)}>
        <div
          key={`delivery-${dl.DeliveryLocationId}`}
          className="delivery__cell flex flex-justify-between"
          style={isDark ? styles.darkCell : styles.cell}
        >
          <div>
            <p
              className="tertiary clear-margins fd-h4"
              style={
                Radium.getState(
                  this.state,
                  `delivery-${dl.DeliveryLocationId}`,
                  ':active',
                ) ||
                Radium.getState(
                  this.state,
                  `delivery-${dl.DeliveryLocationId}`,
                  ':hover',
                )
                  ? styles.secondary
                  : isDark
                  ? styles.primary
                  : styles.tertiary
              }
            >
              {this.props.translate('Deliver_to')}:
            </p>
            {AppConfig.data.DeliveryAddressLayout === 2 ? (
              <React.Fragment>
                <p
                  className="tertiary clear-margins bold fd-h3"
                  style={
                    Radium.getState(
                      this.state,
                      `delivery-${dl.DeliveryLocationId}`,
                      ':active',
                    ) ||
                    Radium.getState(
                      this.state,
                      `delivery-${dl.DeliveryLocationId}`,
                      ':hover',
                    )
                      ? styles.secondary
                      : isDark
                      ? styles.primary
                      : styles.tertiary
                  }
                >
                  {dl.Street + ','}
                </p>
                {dl.Building ? (
                  <p
                    className="tertiary clear-margins bold fd-h3"
                    style={
                      Radium.getState(
                        this.state,
                        `delivery-${dl.DeliveryLocationId}`,
                        ':active',
                      ) ||
                      Radium.getState(
                        this.state,
                        `delivery-${dl.DeliveryLocationId}`,
                        ':hover',
                      )
                        ? styles.secondary
                        : isDark
                        ? styles.primary
                        : styles.tertiary
                    }
                  >
                    {dl.Building}
                  </p>
                ) : null}
                <p
                  className="tertiary clear-margins bold fd-h3"
                  style={
                    Radium.getState(
                      this.state,
                      `delivery-${dl.DeliveryLocationId}`,
                      ':active',
                    ) ||
                    Radium.getState(
                      this.state,
                      `delivery-${dl.DeliveryLocationId}`,
                      ':hover',
                    )
                      ? styles.secondary
                      : isDark
                      ? styles.primary
                      : styles.tertiary
                  }
                >
                  {dl.Town}
                  {dl.PostCode ? `, ${dl.PostCode}` : ''}
                </p>
              </React.Fragment>
            ) : (
              <p
                className="tertiary clear-margins bold fd-h3"
                style={
                  Radium.getState(
                    this.state,
                    `delivery-${dl.DeliveryLocationId}`,
                    ':active',
                  ) ||
                  Radium.getState(
                    this.state,
                    `delivery-${dl.DeliveryLocationId}`,
                    ':hover',
                  )
                    ? styles.secondary
                    : isDark
                    ? styles.primary
                    : styles.tertiary
                }
              >
                {dl.Building ? `${dl.Building}` : ''}{' '}
                {`${dl.Street} ${dl.Town}`}
              </p>
            )}
          </div>
          {/* <div
            className="delivery__cell__map"
            style={
              Radium.getState(
                this.state,
                `delivery-${dl.DeliveryLocationId}`,
                ':active'
              ) ||
              Radium.getState(
                this.state,
                `delivery-${dl.DeliveryLocationId}`,
                ':hover'
              )
                ? styles.mapHover
                : isDark
                ? styles.darkMap
                : styles.map
            }
          >
            <GoogleMap
              center={[dl.Coordinates.Latitude, dl.Coordinates.Longitude]}
              width={128}
              height={96}
              zoom={15}
              scale={2}
              markers={markers}
              apiKey="AIzaSyDPmaK_ZeZzYITQHT9KpftobsXIz3r8SWo"
              stretch={false}
            />
          </div> */}
        </div>
      </Link>
    );
  };

  public trackCollection = () => {
    Track('Maps', 'Collection Selected');
  };

  public renderCollection(config: Api.AppConfig): JSX.Element | null {
    const { AppConfig, translate, AppDesignScheme, isDark } = this.props;

    if (AppConfig.status != 'success') {
      return null;
    }

    if (!config.PickupEnabled) {
      return null;
    }

    let link = '/collection';

    if (
      !config.DisplayPickupRestaurantListScreen &&
      this.props.CollectionSummaries.status === 'success'
    ) {
      const skip = find(
        this.props.CollectionSummaries.data,
        (r) => r.SkipToThisPhysicalRestaurant,
      );
      if (skip) {
        link =
          '/restaurant/' +
          skip.VirtualRestaurantId +
          '/collection/' +
          skip.PhysicalRestaurantId;
      }
    }

    const styles = {
      primary: {
        color: AppDesignScheme.Primary,
      },
      secondary: {
        color: AppDesignScheme.Secondary,
      },
      darkButtonPrimary: {
        backgroundColor: 'transparent',
        borderColor: AppDesignScheme.Primary,
        ':hover': {
          borderColor: AppDesignScheme.Secondary,
        },
        ':active': {},
        ':focus': {
          borderColor: AppDesignScheme.Secondary,
        },
      },
      buttonPrimary: {
        backgroundColor: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString(),
        borderColor: AppDesignScheme.Secondary,
        ':hover': {
          borderColor: AppDesignScheme.Secondary,
        },
        ':active': {},
        ':focus': {
          borderColor: AppDesignScheme.Secondary,
        },
      },
      buttonActive: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString(),
      },
      buttonHover: {
        backgroundColor: AppDesignScheme.Secondary,
      },
    };

    return (
      <div>
        <SectionHeader>
          <SectionHeaderIcon>
            <Icon
              fontSize="large"
              aria-hidden
              color="inherit"
              className="fa fa-shopping-basket"
            />
          </SectionHeaderIcon>
          <SectionHeaderText title={translate('Collection')} />
        </SectionHeader>

        <Link onClick={this.trackCollection} to={link}>
          <button
            className="fd-button fd-button--big fd-button--primary"
            key="collection-button"
            data-fd="delivery-collection"
            style={
              [
                isDark ? styles.darkButtonPrimary : styles.buttonPrimary,
                Radium.getState(this.state, 'collection-button', ':active')
                  ? styles.buttonActive
                  : Radium.getState(this.state, 'collection-button', ':hover')
                  ? styles.buttonHover
                  : null,
              ] as any
            }
          >
            <span className=" flex flex-align-center flex-justify-center">
              <i
                className="material-icons secondary"
                style={
                  Radium.getState(this.state, 'collection-button', ':hover') ||
                  Radium.getState(this.state, 'collection-button', ':active')
                    ? styles.primary
                    : styles.secondary
                }
                aria-hidden="true"
              >
                <CollectionIcon height={27} width={27} aria-hidden />
              </i>
              <p
                className="clear-margins secondary"
                style={
                  Radium.getState(this.state, 'collection-button', ':hover') ||
                  Radium.getState(this.state, 'collection-button', ':active')
                    ? styles.primary
                    : isDark
                    ? styles.primary
                    : styles.secondary
                }
              >
                {AppConfig.data.DineInEnabled && !AppConfig.data.PickupEnabled
                  ? translate('Order_for_dinein')
                  : AppConfig.data.DineInEnabled && AppConfig.data.PickupEnabled
                  ? translate('Order_for_collection_dinein')
                  : translate('Order_for_collection')}
              </p>
            </span>
          </button>
        </Link>
      </div>
    );
  }

  // TODO should be in PageLayout > Login component
  public renderLogInButton = (): JSX.Element | null => {
    if (this.props.LoggedIn) {
      return null;
    }

    const { AppDesignScheme, isDark } = this.props;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary,
      },
      secondary: {
        color: AppDesignScheme.Secondary,
      },
      panel: {
        backgroundColor: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString(),
        borderColor: tinycolor(AppDesignScheme.Primary)
          .darken(20)
          .toString(),
        boxShadow: `1px 1px 7px -5px ${AppDesignScheme.Secondary}`,
      },
      darkPanel: {
        backgroundColor: tinycolor(AppDesignScheme.Tertiary)
          .lighten(10)
          .toString(),
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString(),
        boxShadow: `1px 1px 7px -5px ${tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString()}`,
      },
      darkButtonPrimary: {
        backgroundColor: 'transparent',
        borderColor: AppDesignScheme.Primary,
        ':hover': {
          borderColor: AppDesignScheme.Secondary,
        },
        ':active': {},
        ':focus': {
          borderColor: AppDesignScheme.Secondary,
        },
      },
      buttonPrimary: {
        backgroundColor: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString(),
        borderColor: AppDesignScheme.Secondary,
        ':hover': {
          borderColor: AppDesignScheme.Secondary,
        },
        ':active': {},
        ':focus': {
          borderColor: AppDesignScheme.Secondary,
        },
      },
      buttonActive: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString(),
      },
      buttonHover: {
        backgroundColor: AppDesignScheme.Secondary,
      },
    };

    return (
      <div>
        <Hidden mdUp>
          <Divider />
        </Hidden>
        <div
          className="fd-panel"
          style={isDark ? styles.darkPanel : styles.panel}
        >
          <p
            className="secondary clear-margin-top"
            style={isDark ? styles.primary : styles.secondary}
          >
            {this.props.translate('Click_to_log_in')}
          </p>
          <Link to="/phone">
            <button
              className="fd-button fd-button--full-width fd-button--primary"
              key="login-button"
              data-fd="button-login"
              style={
                [
                  isDark ? styles.darkButtonPrimary : styles.buttonPrimary,
                  Radium.getState(this.state, 'login-button', ':active')
                    ? styles.buttonActive
                    : Radium.getState(this.state, 'login-button', ':hover')
                    ? styles.buttonHover
                    : null,
                ] as any
              }
            >
              <p
                className="clear-margins secondary"
                style={
                  Radium.getState(this.state, 'login-button', ':hover') ||
                  Radium.getState(this.state, 'login-button', ':active')
                    ? styles.primary
                    : isDark
                    ? styles.primary
                    : styles.secondary
                }
              >
                {this.props.translate('Login')}
              </p>
            </button>
          </Link>
        </div>
      </div>
    );
  };

  public renderDelivery(config: Api.AppConfig): JSX.Element | null {
    if (!config.DeliveryEnabled) {
      return null;
    }

    return (
      <div>
        <SectionHeader>
          <SectionHeaderIcon>
            <Icon
              fontSize="large"
              aria-hidden
              color="inherit"
              className="ei icon_pin"
            />
          </SectionHeaderIcon>
          <SectionHeaderText
            id="skip-to-content"
            title={this.props.translate('Delivery')}
            subTitle={this.props.translate('Deliver_to')}
          />
        </SectionHeader>

        {this.props.DeliveryLocations.status != 'success'
          ? `${this.props.translate('Loading')}...`
          : this.props.DeliveryLocations.data.map(this.locationButton)}

        {this.newLocationButton()}

        {this.props.isLoggedIn && (
          <AboutMyData
            style={{ marginBottom: '-16px' }}
            translate={this.props.translate}
          />
        )}

        <Divider />
      </div>
    );
  }

  public render(): JSX.Element {
    const { AppConfig, Customer, isDark, AppDesignScheme } = this.props;

    if (AppConfig.status != 'success') {
      return <LoadingPanel AppDesignScheme={AppDesignScheme} isDark={isDark} />;
    }

    let permissionConsentDialog = null;
    if (Customer.status === 'success' && !!Customer.data.EmailAddress) {
      permissionConsentDialog = <PermissionConsentDialog />;
    }

    return (
      <MainLayout>
        <div className="container">
          <div className="row delivery">
            <div className="col-md-12">
              <div style={{ marginTop: '20px' }} />
              {this.backLink()}
            </div>
            <div className="col-md-8 col-lg-8 col-sm-12">
              {this.renderDelivery(AppConfig.data)}
              {this.renderCollection(AppConfig.data)}
            </div>
            <div className="col-md-4 col-md-4 col-sm-12">
              {this.renderLogInButton()}
            </div>
          </div>
          {permissionConsentDialog}
        </div>
      </MainLayout>
    );
  }
}

// const mapStateToProps = (state: Store.State): StateProps => {
//   return {
//     Config: state.flipdish.Config,
//     DeliveryLocations: state.flipdish.DeliveryLocations,
//     AppConfig: state.flipdish.AppConfig,
//     DeviceId: state.flipdish.Config.DeviceId,
//     deliveryOptions: state.deliveryOptions,
//     LastRestaurantUrl: state.flipdish.LastRestaurantUrl,
//     CollectionSummaries: state.flipdish.CollectionSummaries,
//     LoggedIn: state.flipdish.Customer.status === 'success',
//     Customer: state.flipdish.Customer,
//     isDark: state.flipdish.isDark,
//     translate: getTranslate(state.locale),
//     AppDesignScheme: state.appDesignScheme,
//     isLoggedIn: selectors.isLoggedIn(state)
//   };
// };

// const mapDispatchToProps = (dispatch: any): DispatchProps => {
//   return {
//     PushLoginUrl: () => {
//       dispatch(PushAfterLogin(window.location.hash.substr(1)));
//     }
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(Radium(Delivery));

export default Radium(Delivery);
